<template>
  <v-row justify="center">
    <v-dialog v-model="product_dialog" max-width="700px" persistent>
      <v-card>
        <v-card-title class="pb-5">멤버십 적용 상품 설정 </v-card-title>
        <v-card-subtitle class="pb-4"
          >구매시 [M-CLUB] 멤버십 회원으로 적용하려는 상품을
          선택해주세요.</v-card-subtitle
        >
        <v-divider></v-divider>
        <div class="px-2">
          <v-card-text class="pb-4 d-flex">
            <v-select
              v-model="product_search_type"
              :items="product_search_value"
              label="검색 타입 선택"
              dense
              outlined
              hide-details
              class="mr-3"
              style="width: 20px;"></v-select>
            <v-text-field
              v-model="match_product_name"
              label="검색어 입력"
              persistent-hint
              single-line
              class="pt-0 mr-3"
              outlined
              dense
              hide-details
              @keypress.enter="getProduct()"
            ></v-text-field>
            <v-btn
              large
              color="grey darken-4"
              class="white--text"
              dense
              height="40"
              style="width:120px;"
              @click="getProduct()"
              :loading="search_loading"
              >조회</v-btn
            >
          </v-card-text>
        </div>

        <div class="px-2">
          <v-card-text class="pb-4 pt-0">
            <v-card outlined style="max-height: 400px" class="overflow-y-auto">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                class="elevation-1"
                no-data-text="조회 내역이 없습니다."
              >
                <template v-slot:item="{ item }">
                  <tr :style="tr_style">
                    <td class="text-start py-3">
                      <div class="d-flex">
                        <div>
                          <p class="mb-0 caption">
                            <v-img
                              :src="item.image_url"
                              width="60px"
                              height="60px"
                            ></v-img>
                          </p>
                        </div>
                        <div class="pt-1 pl-3">
                          <p class="mb-0 caption">
                            [{{ item.product_code }}] {{ item.product_name }}
                          </p>
                          <p class="mb-0 caption">
                            판매가: {{ item.price | numberFormat }}원
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="text-center py-3">
                      <div>
                        <v-btn
                          small
                          color="primary"
                          class="white--text add_product"
                          @click="addProduct(item)"
                          :loading="add_set_product_loading"
                          >상품 선택</v-btn
                        >
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </div>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="product_dialog = false"
            >닫기</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style scoped>
.add_product >>> .v-progress-circular {
  height: 18px !important;
  width: 18px !important;
}
</style>
<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/membership/filters.js";

export default {
  data() {
    return {
      product_dialog: false,
      match_product_name: null,
      product_search_type: 'code',
      product_search_value: [
        { text: "상품코드", value: "code" },
        { text: "상품명", value: "name" },
      ],
      headers: [
        {
          text: "상품정보",
          align: "start",
          sortable: false,
          value: "product_name",
          width: 500,
        },
        {
          text: "선택",
          align: "center",
          sortable: false,
          value: "product_id",
        },
      ],
      items: [],
      set_product_list: [],
      search_loading: false,
      add_set_product_loading: false,
      tr_style: "vertical-align: top;",
    };
  },
  mixins: [CommonMixin],
  filters: Filters,
  methods: {
    show: async function() {
      this.reset();
      this.set_product_list = this.$parent.product_list;
      this.product_dialog = true;
    },
    reset: function() {
      this.items = [];
      this.match_product_name = null;
      this.product_search_type = 'code';
    },
    getProduct: async function() {
      this.items = [];
      let result = [];

      if (!this.match_product_name) {
        if (this.product_search_type === "code") {
          alert("상품코드를 입력하세요.");
        } else {
          alert("상품명을 입력하세요.");
        }
        return;
      }

      this.search_loading = true;
      let _set_param = {
        //search_type: "product_name",
        search_type: "product_" + this.product_search_type,
        search_value: this.match_product_name,
      };
      try {
        result = await M.api(
          M.entry("/get/membership/products/search"),
          _set_param
        );
        for (const item of result) {
          // set_product_list 에 속하지 않은 상품만 노출 함
          if (
            !this.set_product_list.some((e) => e.product_no === item.product_no)
          ) {
            if (item.list_image.length > 0) {
              item.image_url = item.list_image[0];
            }
            this.items.push(item);
          }
        }
      } catch (e) {
        //
      }
      this.search_loading = false;
    },
    addProduct: async function(params) {
      this.add_set_product_loading = true;
      let _message = "";
      const setData = {
        product_no: params.product_no,
        product_name: params.product_name,
      };
      try {
        const result = await M.api(
          M.entry("/post/membership/products"), setData
        );
        if (result) {
          _message = "멤버십 적용 상품 설정되었습니다.";
          const setProduct = {
            product_no: params.product_no,
            product_name: params.product_name,
            is_delete: false,
          };
          await this.$parent.addProductList(setProduct);
          const del_index = this.items.findIndex(
            (e) => e.product_no === params.product_no
          );
          this.items.splice(del_index, 1);
        }
      } catch (e) {
        _message = "멤버십 적용 상품 설정 실패하였습니다.";
        console.log("add product false reason is ", e);
      }

      setTimeout(() => {
        alert(_message);
        this.add_set_product_loading = false;
      }, 500);
    },
  },
};
</script>
